import React from 'react';
import PropTypes from 'prop-types';
import NextHead from 'next/head';

import { serializeJsonLd } from './serializeJsonLd';

// schema.org/FAQPage JSON-LD. Answers may contain HTML (Google accepts limited
// markup in Answer.text). Built as an object and serialized with JSON.stringify
// so questions/answers can safely contain quotes or newlines.

// Maps product content `faq` entries ({ caption, description }) to items.
export const faqContentToItems = (faq) =>
  faq.map((item) => ({ question: item.caption, answer: item.description }));

const ScriptMarkupFaq = (props) => {
  if (!Array.isArray(props.items) || props.items.length === 0) {
    return null;
  }

  const data = {
    '@context': 'https://schema.org/',
    '@type': 'FAQPage',
    mainEntity: props.items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const json = serializeJsonLd(data);

  return (
    <NextHead>
      <script
        key="ScriptMarkupFaq"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: json }}
      />
    </NextHead>
  );
};

ScriptMarkupFaq.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    }),
  ),
};

export default ScriptMarkupFaq;
